"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timePeriodSchema = exports.dateTimeSchema = exports.dateSchema = void 0;
const zod_1 = require("zod");
// TODO: refine date schema check or zod update (the latest miniflare stil lists zod@3.22 as its dep)
exports.dateSchema = zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
exports.dateTimeSchema = zod_1.z.string().datetime({ offset: true });
exports.timePeriodSchema = zod_1.z
    .object({
    start: zod_1.z.union([exports.dateSchema, exports.dateTimeSchema]).describe("Start date (or time) of a voting period in the ISO 8601 format"),
    end: zod_1.z.union([exports.dateSchema, exports.dateTimeSchema]).describe("End date (or time) of a voting period in the ISO 8601 format"),
})
    .strict()
    .describe("Time period from-to");
